const hopId = '__hop_id';

export const addHopIdToSessionStorage = (userId: number) => {
  sessionStorage.setItem(hopId, `${new Date().getTime()}_${userId}`);
};

export const addHopIdToHeader = (): Record<string, string> => {
  const tabHopId = window.sessionStorage.getItem(hopId);

  return tabHopId == null ? {} : { 'X-Hop-Id': tabHopId };
};
